export const NO_IMAGE_URL = '/img/noimage.gif';
export const LOGO_URL = '/img/logo.svg';
export const NOT_FOUND_IMAGE_URL = '/img/notfound-img.png';
export const NOT_FOUND_TEXT_URL = '/img/notfound-txt-outline.png';
export const SIGN_IN_BACKGROUND_IMAGE = '/img/bg.png';
export const SIGN_IN_LOGO_IMAGE = '/img/logo.svg';
